import v4 from '../../../../node_modules/uuid/dist/esm-browser/v4.mjs';

const isTestPublicToken = (token)=>token.includes('public-token-test');
const createEventId = ()=>`event-id-${v4()}`;
const createAppSessionId = ()=>`app-session-id-${v4()}`;
const createPersistentId = ()=>`persistent-id-${v4()}`;
const removeResponseCommon = ({ request_id, status_code, ...rest })=>rest;
const omitUser = (resp)=>{
    const { __user, ...rest } = resp;
    return rest;
};

export { createAppSessionId, createEventId, createPersistentId, isTestPublicToken, omitUser, removeResponseCommon };
//# sourceMappingURL=index.mjs.map
